import PropTypes from "prop-types";
import ProductImage from "../../../../ProductImage";
import LazyProductHeroContainer from "../../../../LazyProductHeroContainer";
import { useState, useEffect } from "react";
import ImageGalleryContainer from "./ImageGalleryContainer";
import styles from "./ImageGalleryWithPreview.css";
import classnames from "classnames";

const ImageGalleryWithPreview = ({
  additionalImageUrls,
  className,
  imageUrl,
  onLoad,
  onTransitionEnd
}) => {
  const [animate, setAnimate] = useState(false);
  const [hintImageLoaded, setHintImageLoaded] = useState(false);
  const [hintImage, ...remainingImages] = additionalImageUrls;

  useEffect(() => {
    if (hintImageLoaded) {
      setAnimate(true);
    }
  }, [hintImageLoaded]);

  const removeAnimation = () => setAnimate(false);

  return (
    <ImageGalleryContainer
      onTouchStart={removeAnimation}
      onTouchImages={remainingImages}
      onAnimationEnd={removeAnimation}
      primaryImageProps={{
        imageUrl,
        className,
        onLoad,
        onTransitionEnd
      }}
      className={classnames({ [styles.animate]: animate })}
    >
      <LazyProductHeroContainer
        key={hintImage}
        doLoad={true}
        render={({ onLoad, ...lazyRest }) => (
          <ProductImage
            {...{
              imageUrl: hintImage,
              onLoad: () => {
                onLoad();
                setHintImageLoaded(true);
              },
              ...lazyRest
            }}
          />
        )}
      />
      {!hintImageLoaded && <div />}
    </ImageGalleryContainer>
  );
};

ImageGalleryWithPreview.propTypes = {
  additionalImageUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
  onLoad: PropTypes.func,
  onTransitionEnd: PropTypes.func
};

export default ImageGalleryWithPreview;
